module.exports = __webpack_public_path__ + "img/tools_hr_banner.ee663924.jpg";